import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e0e6e0b2&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=e0e6e0b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e6e0b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0e6e0b2')) {
      api.createRecord('e0e6e0b2', component.options)
    } else {
      api.reload('e0e6e0b2', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e0e6e0b2&scoped=true", function () {
      api.rerender('e0e6e0b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/welfare/detail.vue"
export default component.exports